import { Flex } from '@lemonade-hq/cdk';
import type React from 'react';

interface PizzaContainerProps {
  readonly children: React.ReactNode;
  readonly showBrandsImage?: boolean;
}

export const PizzaContainer: React.FC<PizzaContainerProps> = ({ children, showBrandsImage }) => {
  return (
    <Flex
      alignContent="space-between"
      flexWrap="wrap"
      justifyContent="center"
      mx="20px"
      pb={showBrandsImage ? ['31px', '33px'] : ['60px', '10px']}
    >
      {children}
    </Flex>
  );
};
